import { Button, Dialog, DialogContent, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import MuiDialogHeader from "../Shared/MuiDialogHeader";
import InfoDialog from "../Shared/InfoDialog";
import { IsEmail } from "../Shared/IsEmail";
import { useGateApi } from "../Api/useGateApi";
import { AuthGateApiClient, ResetUserPasswordSendMailRequest } from "../Api/ApiServerHooks";
import { useTranslation } from "react-i18next";

interface ResetPasswordDialogProps {
    isOpen: boolean;
    onClose: () => void;
}
export default function ResetPasswordDialog(props: ResetPasswordDialogProps) {
    const { isOpen, onClose } = props;
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [email, setEmail] = useState('');
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoProps, setInfoProps] = useState<{ label: string, text: string }>();
    const { unauthorizedApi } = useGateApi(AuthGateApiClient);
    const { t } = useTranslation();

    useEffect(() => {
        setEmail('');
    }, []);

    useEffect(() => {
        setEmail('');
    }, [isOpen]);

    return (
        <Dialog onClose={() => onClose()} open={isOpen}>
            <MuiDialogHeader showCloseText title={t('Users.ResetPasswordTitle')} onClose={() => onClose()} />
            <DialogContent>
                <div>
                    <div>
                        <TextField
                            sx={{ margin: '12px', marginLeft: '24px', width: '350px' }}
                            label={t('Users.Email')}
                            size='small'
                            variant='outlined'
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); }} />
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                        <Button variant='contained' sx={{ margin: 'auto' }} disabled={!IsEmail(email) || buttonDisabled} onClick={() => {
                            setButtonDisabled(true);
                            unauthorizedApi.resetPasswordSendMail(new ResetUserPasswordSendMailRequest({email: email})).then((e) => {
                                if (e.ok) {
                                    setInfoProps({ label: t('Info'), text: t('Users.ResetPasswordMailSent') });
                                    setInfoOpen(true);
                                }
                                else {
                                    setInfoProps({ label: t('Error'), text: t('Users.ResetPasswordError') });
                                    setInfoOpen(true);
                                }
                                setButtonDisabled(false);
                            });
                        }}>{t('Users.ResetPasswordButton')}</Button>
                    </div>
                    {infoProps && <InfoDialog onClose={() => {
                        setInfoOpen(false);
                        onClose();
                    }} open={infoOpen} label={infoProps.label} text={infoProps.text} />}
                </div>
            </DialogContent>
        </Dialog>
    )
}
